var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCityNumber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.70761 5.24023L14.4143 10.9469L11.2809 14.0802C11.2809 14.0802 12.4543 17.4269 17.9876 20.7869L21.1343 17.6936L26.8663 23.4246C26.8663 23.4246 21.1743 31.9336 10.8009 21.4669C0.000310101 10.5698 8.70761 5.24023 8.70761 5.24023Z",
    stroke: "#484848",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCityNumber);
export default __webpack_public_path__ + "static/media/CityNumber.13ffb4f4e7b7b1481c45854824064b7d.svg";
export { ForwardRef as ReactComponent };